import React from "react";
import CardPost from "./../Cards/CardPost";
import { useSelector, useDispatch } from "react-redux";

export default function Conversations({ options, posts }) {
  const { postId, username, name, userId } = useSelector(state => ({
    ...state.Post,
    ...state.User
  }));

  const dispatch = useDispatch();
  const closeSideBar = () => {
    dispatch({
      type: "CLOSE_SIDEBAR"
    });
  };

  const changePost = (post, title, urlImg, creator) => {
    dispatch({
      type: "SWITCH_POST",
      payload: { postId,  post,  userId }
    });
    dispatch({
      type: "CHANGE_POST",
      payload: { postId: post, creator, urlImg, title }
    });
  };

  const Posts = ({ posts }) => {
    return posts.map(post => (
      <CardPost
        changePost={changePost}
        postId={postId}
        key={post._id}
        closeSideBar={closeSideBar}
        {...post}
      />
    ));
  };
  return (
    <section className={options === 0 ? "chats active scroll" : "chats scroll"}>
      {posts && <Posts posts={posts} />}
    </section>
  );
}
